import React, { useState } from 'react';
import { Box, Typography, useTheme, useMediaQuery } from '@mui/material';
import { Icon } from '@iconify/react';
import TopBar from '../components/TopBar';
import Sidebar from '../components/Sidebar';
import MakerManualSettlementTable from '../components/MakerManualSettlementTable';
interface MakerManualSettlementProps {
  onLogout: () => void;
}
export default function MakerManualSettlement({
  onLogout
}: MakerManualSettlementProps) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  return <Box sx={{
    display: 'flex',
    width: '100%',
    minHeight: '100vh',
    backgroundColor: '#F8FAFC',
    overflow: 'hidden'
  }} data-id="element-4704">
      <TopBar onMenuClick={handleDrawerToggle} onLogout={onLogout} title="Maker - Manual Settlement" data-id="element-4705" />
      <Sidebar open={mobileOpen} onClose={handleDrawerToggle} activePage="maker-manual-settlement" data-id="element-4706" />
      <Box component="main" sx={{
      flexGrow: 1,
      py: 2,
      px: 1,
      width: {
        xs: '100%',
        sm: `calc(100% - 240px)`
      },
      maxWidth: '100%',
      ml: {
        xs: 0,
        sm: '240px'
      },
      mt: 8,
      overflow: 'hidden'
    }} data-id="element-4707">
        <Box sx={{
        maxWidth: '100%'
      }} data-id="element-4708">
          <Box sx={{
          display: 'flex',
          alignItems: 'center',
          mb: 2
        }} data-id="element-4709">
            <Icon icon="lucide:inbox" width={28} height={28} color="#0EA5E9" data-id="element-4710" />
            <Typography variant="h5" component="h1" sx={{
            ml: 1.5,
            fontWeight: 600
          }} data-id="element-4711">
              Maker Inbox - Manual Settlement
            </Typography>
          </Box>
          <MakerManualSettlementTable data-id="element-4712" />
        </Box>
      </Box>
    </Box>;
}